import { useEffect, useState } from "react";

//contexts
import { useSampleContext } from "../../contexts";

//components
import { CardA, CardB } from "../ui/Cards";

import { ColourSquare } from "./../ui/ColourCircle";

import SampleCons from "../../constants/sample";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const WizardSampleInfo = ({ step, steps, changeStep, pageID }) => {
  const { wasatchSample, setPresumedSubstance, setColour, setTexture } =
    useSampleContext();

  const [selectedPresumed, setSelectedPresumed] = useState(
    wasatchSample.presumed
  );
  const [selectedColour, setSelectedColour] = useState(wasatchSample.colour[1]);
  const [selectedTexture, setSelectedTexture] = useState(
    wasatchSample.texture.id
  );

  const [isDisabled, setIsDisabled] = useState(true);

  //checks if the required fields are filled in
  const validateFields = () => {
    if (
      !wasatchSample?.presumed ||
      !wasatchSample?.colour[1] ||
      !wasatchSample?.texture.id ||
      (wasatchSample?.texture.id === "OTH" &&
        !wasatchSample?.texture.description) ||
      (wasatchSample?.presumed === "Other" &&
        !wasatchSample?.presumedSubDescription)
    ) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  };

  //triggers the validateFields function whenever the selected values change
  useEffect(() => {
    validateFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedPresumed,
    selectedColour,
    selectedTexture,
    wasatchSample.texture.description,
    wasatchSample.presumedSubDescription,
  ]);

  const handleSubstanceChange = (newSubstance, description) => {
    setPresumedSubstance(newSubstance, description);
    setSelectedPresumed(newSubstance);
  };

  const changeColour = (colour, id, text) => {
    setSelectedColour(id);
    setColour([colour, id, text]);
  };

  const allColours = () => {
    return SampleCons.COLOURS?.map((item) => {
      if (!item.label) {
        return (
          <div className='d-flex flex-row w-100 justify-content-center mt-2 flex-wrap'>
            {item.colours.map((colour) => {
              const colourName = colour.label;
              const hexCode = colour.hexCode;
              const id = colour.id;
              return (
                <ColourSquare
                  key={id}
                  id={id}
                  colour={hexCode}
                  selected={selectedColour === id}
                  updateColour={changeColour}
                  text={colourName}
                  showLabel={true}
                />
              );
            })}
          </div>
        );
      } else {
        const colourName = item.label;
        return (
          <div className='d-flex flex-column mx-2 mb-2 text-center '>
            {colourName}
            <div className='d-flex flex-row w-100 justify-content-center '>
              {item.colours.map((colour) => {
                const hexCode = colour.hexCode;
                const id = colour.id;
                return (
                  <ColourSquare
                    key={id}
                    id={id}
                    colour={hexCode}
                    selected={selectedColour === id}
                    updateColour={changeColour}
                    text={colourName}
                  />
                );
              })}
            </div>
          </div>
        );
      }
    });
  };
  const changeTexture = (texture, id, img, description) => {
    setSelectedTexture(id);
    setTexture({ label: texture, id: id, img: img, description: description });
  };

  const allTextures = () => {
    return SampleCons.TEXTURES?.map((item) => {
      return (
        <CardB
          key={item.id}
          id={item.id}
          title={item.label}
          img={item.img}
          description={wasatchSample.texture.description}
          selected={selectedTexture === item.id}
          updateTexture={changeTexture}
        />
      );
    });
  };

  if (step !== pageID) {
    return null;
  }
  return (
    <CardA
      title='Sample Information'
      subtitle='Choose the presumed substance, colour, and texture from the list below. This will not impact your final results.'
      steps={steps}
      step={step - 1}
    >
      <div className='d-flex flex-column h-100 flex-grow-1 pt-3'>
        <div className='d-flex flex-column flex-md-row flex-grow-1'>
          <div className='col-12 col-md-4 px-md-3 py-3 py-md-0'>
            <h6>
              Presumed Substance{" "}
              <small className='fst-italic'>(required)</small>
            </h6>

            <div className='row justify-content-center'>
              <div
                className='accordion w-100 px-2 px-xl-5 '
                id='accordionExample'
              >
                {SampleCons.NEW_PRESUMED_SUBSTANCES.map((substance) => {
                  let indexOfSpace = substance.label.indexOf(" ");
                  let newLabel = substance.label.slice(0, indexOfSpace);

                  let isOpen = substance.drugs.includes(selectedPresumed);

                  return (
                    <div className='accordion-item' key={substance.label}>
                      <h2 className='accordion-header' id={substance.label}>
                        <button
                          className='accordion-button collapsed'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target={`#${newLabel}-collapse`}
                          aria-expanded={String(isOpen)}
                          aria-controls={`${newLabel}-collapse`}
                        >
                          {substance.label}
                        </button>
                      </h2>

                      <div
                        id={`${newLabel}-collapse`}
                        className={
                          isOpen
                            ? "accordion-collapse collapse show"
                            : "accordion-collapse collapse"
                        }
                        aria-labelledby={newLabel}
                        data-bs-parent='#accordionExample'
                      >
                        <div className='accordion-body'>
                          {substance.drugs.map((drug) => {
                            let isChecked = false;
                            if (selectedPresumed === drug) {
                              isChecked = true;
                            }
                            return (
                              <>
                                <div className='form-check'>
                                  <input
                                    key={drug}
                                    type='radio'
                                    className='form-check-input'
                                    name='drugs-radio'
                                    id={drug}
                                    checked={isChecked}
                                    onChange={() =>
                                      handleSubstanceChange(drug, "")
                                    }
                                  />
                                  <label
                                    className='form-check-label'
                                    htmlFor={drug}
                                  >
                                    {drug}
                                  </label>
                                </div>
                                {drug === "Other" && isChecked && (
                                  <div className='form-group mt-2'>
                                    <input
                                      type='text'
                                      className='form-control'
                                      id='otherSubstance'
                                      placeholder='Please specify (required)'
                                      value={
                                        wasatchSample.presumedSubDescription ||
                                        ""
                                      }
                                      style={{ fontSize: "12px" }}
                                      aria-label='Other'
                                      maxLength={"30"}
                                      onChange={(e) =>
                                        handleSubstanceChange(
                                          "Other",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                )}
                              </>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className='d-none d-md-block border-end'></div>
          <div className='d-md-none d-block border-bottom'></div>
          <div className='col-12 col-md-4 px-md-3 py-3 py-md-0'>
            <h6>
              Sample Colour <small className='fst-italic'>(required)</small>
            </h6>

            <div className='d-flex flex-wrap mx-auto justify-content-center'>
              {allColours()}
            </div>
          </div>
          <div className='d-none d-md-block border-end'></div>
          <div className='d-md-none d-block border-bottom'></div>
          <div className='col-12 col-md-4 px-md-3 py-3 py-md-0'>
            <h6>
              Sample Texture <small className='fst-italic'>(required)</small>
            </h6>

            <div className='d-flex flex-wrap justify-content-center'>
              {allTextures()}
            </div>
          </div>
        </div>
      </div>
      <div className='row mt-4 align-content-center'>
        <span className='col-6 d-flex justify-content-center'>
          <button
            type='button'
            className='btn btn-secondary mx-auto w-75'
            onClick={() => changeStep("back")}
          >
            Back
          </button>
        </span>

        <OverlayTrigger
          overlay={
            isDisabled ? (
              <Tooltip id='tooltip-disabled'>
                Please complete all required fields
              </Tooltip>
            ) : (
              <></>
            )
          }
        >
          <span className='col-6 d-flex justify-content-center'>
            <button
              type='button'
              className='btn btn-primary mx-auto w-75 '
              onClick={() => changeStep("forward")}
              disabled={isDisabled}
            >
              Continue
            </button>
          </span>
        </OverlayTrigger>
      </div>
    </CardA>
  );
};

export default WizardSampleInfo;
